module.exports = __webpack_public_path__ + "img/simulados-dos-cursos.ded596c9.png";